import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'error'];

  validate(event) {
    const url = this.inputTarget.value.trim();
    const valid = /^https:\/\/[^\s]+\.sharepoint\.com\/.+/.test(url);
    if (!valid) {
      event.stopPropagation();
      event.preventDefault();
      this.errorTarget.classList.remove('hidden');
    }
  }

  clearError() {
    this.errorTarget.classList.add('hidden');
  }
}
